import { render } from "./SyncRequired.vue?vue&type=template&id=3f45c950&scoped=true"
import script from "./SyncRequired.vue?vue&type=script&lang=js"
export * from "./SyncRequired.vue?vue&type=script&lang=js"

import "./SyncRequired.vue?vue&type=style&index=0&id=3f45c950&lang=stylus&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f45c950"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
